<template>
  <div class="flex flex-col items-center w-full terms mb-128">
    <div
      class="relative w-full max-w-[620px] my-24 lg:my-128 px-20 pt-128 z-20 lg:text-16"
    >
      <h3>{{ $t("terms.title") }}</h3>
      <div>
        {{ $t("terms.description") }}
      </div>

      <template
        v-for="(section, i) in [
          'ip',
          'material_property',
          'fonts',
          'representatives',
          'prohibited',
          'feedback',
          'oversight',
          'privacy',
          'returns',
          'modification',
          'payment',
          'terminations',
          'modifications_to_service',
          'connection_issues',
          'law',
          'dispute',
          'non_liability',
          'liability_conditions',
          'user_data',
          'electronic_communication',
          'presentation',
        ]"
      >
        <h4>{{ `${i + 1}. ${$t(`terms.${section}.title`)}` }}</h4>
        <div>
          {{ $t(`terms.${section}.description`) }}
        </div>
      </template>

      <h4>{{ $t("terms.recommendations.title") }}</h4>
      <i18n-t keypath="terms.recommendations.description" tag="div">
        <SharedLink url="/referrals" :inline="true" class="underline">{{
          $t("terms.recommendations.cta")
        }}</SharedLink>
      </i18n-t>

      <h4>{{ $t("terms.additional.title") }}</h4>
      <div>
        {{ $t("terms.additional.description") }}
      </div>

      <h4>{{ $t("terms.contact.title") }}</h4>
      <div>
        {{ $t("terms.contact.description") }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.terms {
  h4 {
    @apply mt-64;
  }
}
</style>
